const LESS_THAN_20 = [
    'Zero', 'One', 'Two', 'Three', 'Four', 'Five', 'Six', 'Seven', 'Eight', 'Nine',
    'Ten', 'Eleven', 'Twelve', 'Thirteen', 'Fourteen', 'Fifteen', 'Sixteen', 'Seventeen', 'Eighteen', 'Nineteen',
];

const TENS = [
    '', '', 'Twenty', 'Thirty', 'Forty', 'Fifty', 'Sixty', 'Seventy', 'Eighty', 'Ninety',
];

const convertLessThanThousand = (n) => {
    if (n === 0) return '';
    if (n < 20) return LESS_THAN_20[n];
    if (n < 100) {
        const tens = TENS[Math.floor(n / 10)];
        const ones = n % 10;
        return ones ? `${tens} ${LESS_THAN_20[ones]}` : tens;
    }

    const hundreds = Math.floor(n / 100);
    const remainder = n % 100;
    const hundredPart = `${LESS_THAN_20[hundreds]} Hundred`;
    if (remainder === 0) return hundredPart;
    return `${hundredPart} ${convertLessThanThousand(remainder)}`;
};

const integerToWords = (n) => {
    if (n === 0) return 'Zero';

    const billion = Math.floor(n / 1_000_000_000);
    const million = Math.floor((n % 1_000_000_000) / 1_000_000);
    const thousand = Math.floor((n % 1_000_000) / 1_000);
    const remainder = n % 1_000;

    const parts = [];
    if (billion) parts.push(`${convertLessThanThousand(billion)} Billion`);
    if (million) parts.push(`${convertLessThanThousand(million)} Million`);
    if (thousand) parts.push(`${convertLessThanThousand(thousand)} Thousand`);
    if (remainder) parts.push(convertLessThanThousand(remainder));

    return parts.join(' ');
};

/**
 * Formats a BHD amount as spelled-out words for printed invoices.
 * Example: 519.200 -> "FIVE HUNDRED NINETEEN BAHRAINI DINARS AND TWO HUNDRED FILS ONLY"
 */
export const formatAmountInWords = (amount) => {
    if (amount === undefined || amount === null || amount === '') return '';

    const num = parseFloat(amount);
    if (Number.isNaN(num)) return '';

    const [wholeStr, decimalStr] = num.toFixed(3).split('.');
    const whole = parseInt(wholeStr, 10);
    const fils = parseInt(decimalStr, 10);

    const wholeWords = integerToWords(whole);
    let result = wholeWords;
    result += ' BAHRAINI DINARS';
    if (fils > 0) {
        const filsWords = convertLessThanThousand(fils);
        result += ` AND ${filsWords} FILS`;
    }
    result += ' ONLY';

    return result.toUpperCase();
};
